/**
 * Register. GSAP
 *
 * Guarded: gsap/ScrollTrigger aren't loaded by any script tag in this theme, so referencing them
 * unconditionally threw a ReferenceError on every page load -- since this is a module, that throw
 * aborted the entire file's evaluation, silently taking every other custom element defined below
 * (bl-progress-bars included) down with it. Skips cleanly instead until the library is actually added.
 */
if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
  gsap.registerPlugin(ScrollTrigger);
  gsap.config({ trialWarn: false });
  ScrollTrigger.config({
    ignoreMobileResize: true,
    limitCallbacks: true // Only runs callbacks when necessary to save CPU
  });
}

// window.addEventListener("resize", () => {
//   ScrollTrigger.refresh();
// });

/********************************************************
 * HEADER WRAPPER STYLE (WHEN SLIDESHOW IS FIRST SECTION)
 ********************************************************/
(function() {
  const initInsetHeader = () => {
    const triggerSection = document.querySelector('[data-header-inset-trigger]');
    const headerWrapper = document.querySelector('.header__wrapper');

    if (!triggerSection || !headerWrapper) return;

    const observerOptions = {
      root: null,
      threshold: 0,
      rootMargin: `-${headerWrapper.offsetHeight || 80}px 0px 0px 0px` 
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          headerWrapper.style.setProperty('margin-inline', '0.625rem', 'important');
        } else {
          headerWrapper.style.setProperty('margin-inline', '0', 'important');
        }
      });
    }, observerOptions);

    observer.observe(triggerSection);
  };

  if (document.readyState === 'complete') {
    initInsetHeader();
  } else {
    window.addEventListener('load', initInsetHeader);
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-header-inset-trigger]')) {
      initInsetHeader();
    }
  });
})();

/********************************
 * bl_bullet-point-banner.liquid
 ********************************/
if (!customElements.get('bl-bullet-point')) {
  class BlBulletPoint extends HTMLElement {
    constructor() {
      super();
      this.wrapper = this.querySelector('.bl-bp__wrapper');
      this.dots = this.querySelectorAll('.bl-bp__dot');
      this.currentIndex = 0;
      this.timer = null;
      this.scrollTimeout = null;
      this.itemsPerPage = 1;
      this.totalPages = 0;
      this.intervalDuration = 8000;
    }

    connectedCallback() {
      this.updateLayout();
      this.dots.forEach(dot => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          const index = parseInt(dot.getAttribute('data-index'));
          this.goToPage(index, true); 
        });
      });

      this.wrapper.addEventListener('scroll', () => {
        window.clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(() => {
          const newPageIndex = Math.round(this.wrapper.scrollLeft / this.wrapper.offsetWidth);
          if (newPageIndex !== this.currentIndex && newPageIndex < this.totalPages) {
            this.goToPage(newPageIndex, true); 
          }
        }, 50);
      }, { passive: true });

      window.addEventListener('resize', () => this.updateLayout());
      
      requestAnimationFrame(() => this.goToPage(0, false));
    }

    updateLayout() {
      const prevItemsPerPage = this.itemsPerPage;
      this.itemsPerPage = 1;
      this.totalPages = Math.ceil(this.dots.length / this.itemsPerPage);

      this.dots.forEach((dot, index) => {
        dot.style.display = index < this.totalPages ? 'block' : 'none';
      });

      if (prevItemsPerPage !== this.itemsPerPage) {
        this.goToPage(0, true);
      }
    }

    goToPage(index, isManual = false) {
      this.stopTimer();

      if (index >= this.totalPages) index = 0;
      this.currentIndex = index;

      const targetScroll = this.wrapper.offsetWidth * index;
      if (Math.abs(this.wrapper.scrollLeft - targetScroll) > 5) {
        this.wrapper.scrollTo({ left: targetScroll, behavior: 'smooth' });
      }

      this.dots.forEach(dot => dot.classList.remove('is-active'));
      if (this.dots[this.currentIndex]) {
        void this.dots[this.currentIndex].offsetWidth; 
        this.dots[this.currentIndex].classList.add('is-active');
      }

      this.startTimer();
    }

    startTimer() {
      this.stopTimer();
      this.timer = setInterval(() => {
        const nextIndex = (this.currentIndex + 1) % this.totalPages;
        this.goToPage(nextIndex, false);
      }, this.intervalDuration);
    }

    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    disconnectedCallback() {
      this.stopTimer();
    }
  }

  customElements.define('bl-bullet-point', BlBulletPoint);
}

/********************************
 * bl_image-packery.liquid
 ********************************/
if (!customElements.get('bl-background-looping')) {
  class BlBackgroundLooping extends HTMLElement {
    connectedCallback() {
      this.textPath = this.querySelector('.loopTextPath');
      this.path = this.querySelector('path');
      if (!this.textPath || !this.path) return;

      this.offset = 0;
      this.phraseWidthPercent = 0;
      this.animationFrame = null;
      this.resizeObserver = new ResizeObserver(() => this.updateDimensions());
      this.resizeObserver.observe(this);

      this.animate();
    }

    updateDimensions() {
      const totalTextLength = this.textPath.getComputedTextLength();
      const pathLength = this.path.getTotalLength();

      if (totalTextLength > 0) {
        this.phraseWidthPercent = ((totalTextLength / 15) / pathLength) * 100;
      }
    }

    animate() {
      this.offset -= 0.05; 

      if (this.phraseWidthPercent > 0 && Math.abs(this.offset) >= this.phraseWidthPercent) {
        this.offset = 0;
      }

      this.textPath.setAttribute('startOffset', this.offset + '%');
      this.animationFrame = requestAnimationFrame(() => this.animate());
    }

    disconnectedCallback() {
      if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }
  }
  customElements.define('bl-background-looping', BlBackgroundLooping);
}

if (!customElements.get('bl-ip-wrapper')) {
  class BlIpWrapper extends HTMLElement {
    connectedCallback() {
      if (window.innerWidth < 700) {
        const items = this.querySelectorAll('.bl-ip__image');
        if (items.length >= 2) {
          requestAnimationFrame(() => {
            const secondItem = items[1];
            const scrollLeft = secondItem.offsetLeft + (secondItem.offsetWidth / 2) - (this.offsetWidth / 2);
            this.scrollTo({ left: scrollLeft, behavior: 'auto' });
          });
        }
      }
    }
  }
  customElements.define('bl-ip-wrapper', BlIpWrapper);
}

/********************************
 * bl_team-card.liquid
 ********************************/
if (!customElements.get('bl-team-card')) {
  customElements.define('bl-team-card', class extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.openPopup.bind(this));
    }

    connectedCallback() {
      this._reveal_fn();
    }

    _reveal_fn() {
      const tl = gsap.timeline({
        paused: true
      });

      tl.from(this.querySelector(".bl-tc__name_position p"), {
        opacity: 0,
        y: 20,
        duration: 0.4,
        ease: "power2.inOut"
      }, "<")
      
      ScrollTrigger.create({
        trigger: this.closest(".shopify-section"),
        start: "top 60%",
        onEnter: (self) => {
          if (self.progress < 1 && self.direction === 1) {
            tl.play();
            self.kill();
          }
        },
        onEnterBack: (self) => {
          tl.play();
          self.kill(); 
        }
      });
    }
    openPopup() {
      if (window.innerWidth > 999) return;

      const popupId = this.getAttribute('data-card-popup');
      const popup = document.getElementById(popupId);
      
      if (popup) {
        popup.setAttribute('open', '');
        document.body.style.overflow = 'hidden'; 
        if (!popup.dataset.closeBound) {
          const closePopup = () => {
            popup.removeAttribute('open');
            document.body.style.overflow = '';
          };
          
          const overlay = popup.querySelector('.bl-tc__card-popup_overlay');
          if (overlay) overlay.addEventListener('click', closePopup);

          const closeBtn = popup.querySelector('.bl-tc__close-btn');
          if (closeBtn) closeBtn.addEventListener('click', closePopup);

          popup.dataset.closeBound = "true";
        }
      }
    }
  });
}

if (!customElements.get('team-card-popup')) {
  customElements.define('team-card-popup', class extends HTMLElement {
    connectedCallback() {
      this.injectCloseButton();
      
      this.addEventListener('click', (event) => {
        const isOverlay = event.target.classList.contains('bl-tc__card-popup_overlay');
        const isCloseBtn = event.target.closest('.bl-tc__close-btn');
        
        if (isOverlay || isCloseBtn) {
          this.close();
        }
      });
    }

    injectCloseButton() {
      const contentContainer = this.querySelector('div:not(.bl-tc__card-popup_overlay)');
      if (contentContainer && !contentContainer.querySelector('.bl-tc__close-btn')) {
        const closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'bl-tc__close-btn';
        closeBtn.innerHTML = '&times;'; 
        closeBtn.setAttribute('aria-label', 'Close');
        contentContainer.prepend(closeBtn);
      }
    }

    close() {
      this.removeAttribute('open');
      document.body.style.overflow = '';
    }
  });
}

/**************************************
 * bl_central-floating-elements.liquid
 **************************************/
if (!customElements.get('floating-element')) {
  class FloatingElement extends HTMLElement {
    constructor() {
      super();
      this.isAnimated = false;
      this._finalRect = { x: 0, y: 0, w: 0, h: 0 };
      this._handleResize = () => this.calculatePosition();
    }

    connectedCallback() {
      this.init();
      window.addEventListener('resize', this._handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._handleResize);
    }

    init() {
      if (window.innerWidth < 700) return;
      this.style.opacity = '0';
      this.style.visibility = 'hidden';
      this.style.position = 'absolute';
      this.style.whiteSpace = 'nowrap';
      this.style.zIndex = '2';

      const ro = new ResizeObserver(() => {
        if (this.parentElement.offsetHeight > 50) {
          this.initIntersection();
          ro.disconnect();
        }
      });
      ro.observe(this.parentElement);
    }

    initIntersection() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isAnimated) {
            this.isAnimated = true;
            this.calculatePosition(true); 
          }
        });
      }, { threshold: 0.1 });
      observer.observe(this.parentElement);
    }

    resetStyles() {
      const props = ['position','left','top','transform','opacity','visibility','transition','white-space','z-index'];
      props.forEach(p => this.style.removeProperty(p));
      this.classList.remove('is-floating');
      this.isAnimated = false; 
    }

    calculatePosition(triggerAnimation = false) {
      if (window.innerWidth < 700) {
        this.resetStyles();
        return;
      }

      const parent = this.parentElement;
      const allItems = Array.from(parent.querySelectorAll('floating-element'));
      const index = allItems.indexOf(this);
      const total = allItems.length;

      const pW = parent.offsetWidth;
      const pH = parent.offsetHeight;
      const centerX = pW / 2;
      const centerY = pH / 2;

      const myW = this.offsetWidth;
      const myH = this.offsetHeight;

      const half = Math.ceil(total / 2);
      const isTop = index < half;

      let angle;
      const sweep = Math.PI * 0.75; 
      if (isTop) {
        const step = sweep / (half > 1 ? half - 1 : 1);
        angle = -Math.PI + ((Math.PI - sweep) / 2) + (step * index);
      } else {
        const bottomIndex = index - half;
        const bottomTotal = total - half;
        const step = sweep / (bottomTotal > 1 ? bottomTotal - 1 : 1);
        angle = ((Math.PI - sweep) / 2) + (step * bottomIndex);
      }

      const rx = pW * 0.36;
      const ry = pH * 0.38;

      let tx = centerX + Math.cos(angle) * rx - (myW / 2);
      let ty = centerY + Math.sin(angle) * ry - (myH / 2);

      tx = Math.max(20, Math.min(tx, pW - myW - 20));
      ty = Math.max(20, Math.min(ty, pH - myH - 20));

      this._finalRect = { x: tx, y: ty, w: myW, h: myH };

      for (let i = 0; i < index; i++) {
        const other = allItems[i]._finalRect;
        if (!other || other.w === 0) continue;
        const padding = 20;
        if (this._finalRect.x < other.x + other.w + padding && this._finalRect.x + this._finalRect.w + padding > other.x && this._finalRect.y < other.y + other.h + padding && this._finalRect.y + this._finalRect.h + padding > other.y) {
          this._finalRect.y += isTop ? -45 : 45;
          this._finalRect.y = Math.max(20, Math.min(this._finalRect.y, pH - myH - 20));
        }
      }

      this.style.position = 'absolute';
      this.style.left = `${this._finalRect.x}px`;
      this.style.top = `${this._finalRect.y}px`;

      if (triggerAnimation) this.animateIn(index);
    }

    animateIn(index) {
      this.style.visibility = 'visible';
      this.style.opacity = '0';
      this.style.transform = 'translate3d(0, 20px, 0)';
      
      const duration = 1100;
      const delay = index * 120;

      setTimeout(() => {
        this.style.transition = `opacity ${duration}ms ease, transform ${duration}ms cubic-bezier(0.16, 1, 0.3, 1), left 0.3s ease-out, top 0.3s ease-out`;
        this.style.opacity = '1';
        this.style.transform = 'translate3d(0, 0, 0)';

        setTimeout(() => {
          this.style.transition = 'opacity 0.6s ease, left 0.3s ease-out, top 0.3s ease-out';
          this.style.transform = 'translate3d(0, 0, 0)';
          
          this.offsetHeight; 

          requestAnimationFrame(() => {
            this.classList.add('is-floating');
            this.style.setProperty('--float-dur', `${5 + Math.random() * 3}s`);
            this.style.setProperty('--float-del', `${Math.random() * -5}s`);
            this.style.setProperty('--float-offset', `${-10 - Math.random() * 10}px`);
          });
        }, duration);

      }, delay);
    }
  }

  customElements.define('floating-element', FloatingElement);
}

/********************************
 * bl_flex-card.liquid
 ********************************/
if (!customElements.get('bl-flex-card')) {
  class BlFlexCard extends HTMLElement {
    constructor() {
      super();
      this.cards = this.querySelectorAll('.bl-flex_card__card');
      this.isMobileScrollInit = false;
      
      // Bind methods
      this.handleResize = this.handleResize.bind(this);
      this.scrollHandler = this.scrollHandler.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.handleMouseEnter = this.handleMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);

      // Desktop Hover Listeners
      this.cards.forEach(card => {
        card.addEventListener('mouseenter', () => this.handleMouseEnter(card));
        card.addEventListener('mouseleave', this.handleMouseLeave);
      });
      
      window.addEventListener('resize', this.handleResize);
      this.handleResize(); // Init on load
    }
    
    handleResize() {
      if (window.innerWidth <= 999) {
        this.initMobileScroll();
      } else {
        this.destroyMobileScroll();
      }
    }

    /* ==============================
       DESKTOP: Same Row Sibling Logic
    ============================== */
    handleMouseEnter(hoveredCard) {
      if (window.innerWidth < 1000 || hoveredCard.classList.contains('bl-flex_card__full_width_card')) return;
      
      const hoveredRect = hoveredCard.getBoundingClientRect();
      
      this.cards.forEach(card => {
        // If it's not the hovered card, and it's not a full width card
        if (card !== hoveredCard && !card.classList.contains('bl-flex_card__full_width_card')) {
          const cardRect = card.getBoundingClientRect();
          // Check if the top coordinates align (meaning they are in the exact same row)
          // 10px buffer handles sub-pixel rendering discrepancies
          if (Math.abs(cardRect.top - hoveredRect.top) < 10) {
            card.classList.add('is-sibling-hovered');
          }
        }
      });
    }

    handleMouseLeave() {
      this.cards.forEach(card => card.classList.remove('is-sibling-hovered'));
    }
    
    /* ==============================
       MOBILE: Center Scroll Tracker
    ============================== */
    initMobileScroll() {
      if (this.isMobileScrollInit || this.cards.length === 0) return;
      this.isMobileScrollInit = true;

      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.scrollHandler();
    }

    onScroll() {
      if (this.scrollRaf) window.cancelAnimationFrame(this.scrollRaf);
      this.scrollRaf = window.requestAnimationFrame(this.scrollHandler);
    }

    scrollHandler() {
      if (window.innerWidth >= 1000) return;
      
      const viewportCenter = window.innerHeight / 2;
      let closestCard = null;
      let minDistance = Infinity;

      this.cards.forEach(card => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.top + (rect.height / 2);
        const distance = Math.abs(viewportCenter - cardCenter);

        if (distance < minDistance) {
          minDistance = distance;
          closestCard = card;
        }
      });

      if (closestCard && !closestCard.classList.contains('is-active')) {
        this.cards.forEach(c => c.classList.remove('is-active'));
        closestCard.classList.add('is-active');
      }
    }

    destroyMobileScroll() {
      if (this.isMobileScrollInit) {
        window.removeEventListener('scroll', this.onScroll);
        if (this.scrollRaf) window.cancelAnimationFrame(this.scrollRaf);
        this.isMobileScrollInit = false;
      }
      this.cards.forEach(card => card.classList.remove('is-active'));
    }
    
    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      this.destroyMobileScroll();
    }
  }
  
  customElements.define('bl-flex-card', BlFlexCard);
}

/********************************
 * bl_number-counter.liquid
 ********************************/
if (!customElements.get('bl-number-cards')) {
  customElements.define('bl-number-cards', class extends HTMLElement {
    constructor() {
      super();
      this.cards = this.querySelectorAll('.bl-number_card');
      this.counters = this.querySelectorAll('bl-number-counter');
    }

    connectedCallback() {
      this.counters.forEach((counter, index) => {
        const originalText = counter.textContent.trim();
        const targetVal = parseFloat(originalText.replace(/,/g, ''));
        
        if (!isNaN(targetVal)) {
          counter.dataset.target = targetVal;
          counter.dataset.hasComma = originalText.includes(',');
          counter.dataset.decimals = originalText.includes('.') ? originalText.split('.')[1].length : 0;
          counter.textContent = '0';
        }
        if(this.cards[index]) {
          this.cards[index].style.transitionDelay = `${index * 0.15}s`;
        }
      });

      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.classList.add('is-revealed');
            this.startCounting();
            observer.unobserve(this);
          }
        });
      }, { 
        threshold: 0.2,
        rootMargin: "0px 0px -50px 0px"
      });

      this.observer.observe(this);
    }

    startCounting() {
      const duration = 2500;

      this.counters.forEach((counter, index) => {
        const target = parseFloat(counter.dataset.target);
        if (isNaN(target)) return;
        
        const decimals = parseInt(counter.dataset.decimals);
        const hasComma = counter.dataset.hasComma === 'true';

        const formatNumber = (num) => {
          if (hasComma) {
            return num.toLocaleString('en-US', {
              minimumFractionDigits: decimals,
              maximumFractionDigits: decimals
            });
          }
          return num.toFixed(decimals);
        };

        setTimeout(() => {
          let startTimestamp = null;

          const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            
            const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
            
            const currentVal = easeProgress * target;
            counter.textContent = formatNumber(currentVal);

            if (progress < 1) {
              window.requestAnimationFrame(step);
            } else {
              counter.textContent = formatNumber(target);
            }
          };

          window.requestAnimationFrame(step);
        }, index * 150);
      });
    }
  });
}

/********************************************************
 * bl_parallax-banner.liquid
 ********************************************************/
if (!customElements.get('bl-parallax-banner')) {
  class BlParallaxBanner extends HTMLElement {
    connectedCallback() {
      this.track = this.closest('.bl-scroll-track');
      this.slides = Array.from(this.querySelectorAll('.bl-parallax_banner__image_wrapper'));
      
      if (this.slides.length < 2 || !this.track) return;

      this.slides.forEach((slide, index) => {
        slide.style.zIndex = index;
      });

      this.windowWidth = window.innerWidth;

      this.updateDimensions = () => {
        const trackRect = this.track.getBoundingClientRect();
        this.trackAbsoluteTop = trackRect.top + window.scrollY;
        this.trackHeight = trackRect.height;
        this.maxScroll = this.trackHeight - window.innerHeight;
      };

      this.updateDimensions();
      this.onResize = () => {
        if (window.innerWidth !== this.windowWidth) {
          this.windowWidth = window.innerWidth;
          this.updateDimensions();
        }
      };
      window.addEventListener('resize', this.onResize, { passive: true });

      this.lastScrollY = -1;
      
      this.updateFrame = () => {
        if (this.lastScrollY === window.scrollY) {
          this.rafId = requestAnimationFrame(this.updateFrame);
          return;
        }
        this.lastScrollY = window.scrollY;

        const currentTrackTop = this.trackAbsoluteTop - window.scrollY;
        let progress = -currentTrackTop / this.maxScroll;
        progress = Math.max(0, Math.min(1, progress));

        const totalSlides = this.slides.length;
        const progressPerSlide = 1 / (totalSlides - 1);
        const dwellRatio = 0.35; 

        this.slides.forEach((slide, index) => {
          const slideStart = (index - 1) * progressPerSlide;
          const slideEnd = index * progressPerSlide;
          const segmentLength = slideEnd - slideStart;
          const slideActiveStart = slideStart + (segmentLength * dwellRatio);
          
          const nextSlideStart = index * progressPerSlide;
          const nextSlideEnd = (index + 1) * progressPerSlide;
          const nextSegmentLength = nextSlideEnd - nextSlideStart;
          const nextActiveStart = nextSlideStart + (nextSegmentLength * dwellRatio);

          if (index > 0) {
            if (progress <= slideActiveStart) {
              slide.style.transform = `translate3d(0, 100%, 0)`;
            } else if (progress >= slideEnd) {
              slide.style.transform = `translate3d(0, 0%, 0)`;
            } else {
              const slideProgress = (progress - slideActiveStart) / (slideEnd - slideActiveStart);
              const yPos = 100 - (slideProgress * 100);
              slide.style.transform = `translate3d(0, ${yPos}%, 0)`;
            }
          }
          if (index < totalSlides - 1) {
            if (progress >= nextActiveStart && progress <= nextSlideEnd) {
              const fadeProgress = (progress - nextActiveStart) / (nextSlideEnd - nextActiveStart);
              slide.style.opacity = 1 - (fadeProgress * 0.6);
            } else if (progress > nextSlideEnd) {
              slide.style.opacity = 0.4;
            } else {
              slide.style.opacity = 1;
            }
          }

          const slideMidPoint = slideActiveStart + ((slideEnd - slideActiveStart) * 0.5);
          const nextMidPoint = nextActiveStart + ((nextSlideEnd - nextActiveStart) * 0.5);
          
          const isRevealed = index === 0 ? true : progress >= slideMidPoint;
          const isCoveredByNext = index < totalSlides - 1 && progress >= nextMidPoint;
          
          if (isRevealed && !isCoveredByNext) {
            if (!slide.classList.contains('is-active')) slide.classList.add('is-active');
          } else {
            if (slide.classList.contains('is-active')) slide.classList.remove('is-active');
          }
        });

        clearTimeout(this.snapTimeout);
        this.snapTimeout = setTimeout(() => {
          if (progress > 0 && progress < 1) {
            const exactSlide = progress / progressPerSlide;
            const nearestSlide = Math.round(exactSlide); 
            
            if (Math.abs(exactSlide - nearestSlide) > 0.02) {
              const targetProgress = nearestSlide * progressPerSlide;
              const targetScrollTop = this.trackAbsoluteTop + (targetProgress * this.maxScroll);
              
              window.scrollTo({ top: targetScrollTop, behavior: 'smooth' });
            }
          }
        }, 350);

        this.rafId = requestAnimationFrame(this.updateFrame);
      };

      this.rafId = requestAnimationFrame(this.updateFrame);
    }
    
    disconnectedCallback() {
      if (this.rafId) cancelAnimationFrame(this.rafId);
      clearTimeout(this.snapTimeout);
      window.removeEventListener('resize', this.onResize);
    }
  }
  customElements.define('bl-parallax-banner', BlParallaxBanner);
}

/********************************************************
 * bl-multi-image_with_usp.liquid
 ********************************************************/
class AutoLoopImages extends HTMLElement {
  constructor() {
    super();
    this._imageList = this.querySelector("multiple-images-with-text-image-list");
    this._timer = null;
    this._speed = 4000;
  }

  connectedCallback() {
    // Only run if there is more than 1 image
    if (!this._imageList || this._imageList.children.length <= 1) return;

    // Use IntersectionObserver so it only slides when user sees it
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this._startAutoplay();
        } else {
          this._stopAutoplay();
        }
      });
    }, { threshold: 0.1 });

    observer.observe(this);

    // Pause animation when user hovers over the USPs/Content
    this.addEventListener('mouseenter', () => this._stopAutoplay());
    this.addEventListener('mouseleave', () => this._startAutoplay());
  }

  _startAutoplay() {
    this._stopAutoplay();
    this._timer = setInterval(() => {
      // We call the 'next' method that exists on the original MultipleImagesWithTextImageList component
      if (this._imageList && typeof this._imageList.next === 'function') {
        this._imageList.next();
      }
    }, this._speed);
  }

  _stopAutoplay() {
    if (this._timer) clearInterval(this._timer);
  }

  disconnectedCallback() {
    this._stopAutoplay();
  }
}

// Define the custom element
if (!window.customElements.get("auto-loop-images")) {
  window.customElements.define("auto-loop-images", AutoLoopImages);
}

/*
  ------------------------------------------------------------------------------------------------------------------------
  <bl-marquee-text>
  ------------------------------------------------------------------------------------------------------------------------

  Drop-in replacement for the theme's own <marquee-text> (theme.js), used by the announcement bar, the
  "Scrolling text" section and "Scrolling icon text (BL)".

  Both elements do the same job: set --marquee-animation-duration, which the translateFull animation in
  theme.css consumes. The difference is how the duration is derived.

  The theme's version:

    duration = speed * slowFactor * itemWidth / containerWidth
    slowFactor = 1 + (min(1600, containerWidth) - 375) / (1600 - 375)

  Each copy of the content translates by 100% of its own width over that duration, so the actual on-screen
  speed is itemWidth / duration = containerWidth / (speed * slowFactor). Container width varies by roughly
  4.3x between a 375px phone and a 1600px desktop while slowFactor only ever doubles, so the marquee ends
  up moving about twice as fast on desktop as it does on mobile -- the same setting reads as two different
  speeds depending on the screen.

  This version drops containerWidth from the equation entirely:

    duration = itemWidth * speed / REFERENCE_WIDTH

  which gives a constant REFERENCE_WIDTH / speed pixels per second at every viewport size. "Scrolling
  speed: 10s" now means the same physical speed everywhere.

  REFERENCE_WIDTH is 768 because that is what the old formula already worked out to across the desktop
  range (669px/s at 1024 wide, 770 at 1440, 800 at 1600, all divided by speed). Desktop therefore looks
  unchanged; mobile, which used to sit at ~385/speed, speeds up to match it. Existing "scrolling speed"
  values keep the meaning they were tuned to on desktop.
*/
import { PageDots } from 'theme';
import { animate } from 'vendor';

const REFERENCE_WIDTH = 768;

class BlMarqueeText extends HTMLElement {
  connectedCallback() {
    // The repeated copy whose width sets the loop distance -- the first <span>, matching the markup the
    // theme's own element expects.
    this._item = this.querySelector('span');

    if (!this._item) return;

    if (window.ResizeObserver) {
      // Observing the item rather than the container: the item is the only thing the duration depends on,
      // and it is what actually changes when a webfont swaps in or a breakpoint alters the item's gaps.
      // ResizeObserver fires once on observe, so this also covers the initial measurement.
      this._resizeObserver = new ResizeObserver(() => this._updateDuration());
      this._resizeObserver.observe(this._item);
    } else {
      this._updateDuration();
    }
  }

  disconnectedCallback() {
    this._resizeObserver?.disconnect();
  }

  _updateDuration() {
    // clientWidth rather than getBoundingClientRect(), which would report the transformed box: these items
    // are mid-translate almost all the time, and a section reveal animation can add a scale on top.
    const itemWidth = this._item.clientWidth;

    if (!itemWidth) return;

    const scrollingSpeed = parseFloat(this.getAttribute('scrolling-speed')) || 5;

    this.style.setProperty('--marquee-animation-duration', `${((itemWidth * scrollingSpeed) / REFERENCE_WIDTH).toFixed(3)}s`);
  }
}

if (!window.customElements.get('bl-marquee-text')) {
  window.customElements.define('bl-marquee-text', BlMarqueeText);
}

/*
  ------------------------------------------------------------------------------------------------------------------------
  <bl-progress-bars>
  ------------------------------------------------------------------------------------------------------------------------

  Used by more than one section now (Slideshow (BL), Split slideshow (BL)), so it lives here rather than
  duplicated inline in each -- see CLAUDE.local.md's rule on when a control style graduates out of a
  single section file.

  Extends the theme's own <page-dots> so click-to-navigate, keyboard focus and aria-current syncing are
  all inherited for free -- only the animated fill is new.

  With autoplay on, only one bar ever holds a meaningful fill at a time:
    - the current slide: bar grows from 0% to 100% in step with the carousel's own autoplay timer
    - the slide that was just active: its bar retracts from 100% back to 0% over a fixed 0.5s, run
      independently of the next bar's growth -- the retract does not delay the next bar starting
    - every other slide: bar stays empty

  Timing comes straight from the carousel's Player instance (exposed as `.player` on any element built
  on top of EffectCarousel, e.g. <slideshow-carousel>), so it always matches that section's own "Change
  slides every X seconds" setting with no duplicated timing logic. When autoplay is off there is no
  Player and therefore no time-based progress to animate, so it falls back to a static 3-state history
  look instead (already viewed = fully filled, current/upcoming = empty), driven purely by clicks.

  Retract controls are tracked per bar index (not a single shared variable) so that clicking through
  slides faster than the 0.5s retract can finish never stops the wrong bar's animation.
*/
if (!window.customElements.get('bl-progress-bars')) {
  window.customElements.define(
    'bl-progress-bars',
    class extends PageDots {
      connectedCallback() {
        super.connectedCallback();

        this._fills = Array.from(this.querySelectorAll('.bl-progress-bars__fill'));
        this._growingControl = null;

        const { signal } = this._abortController;

        /*
          The index comes off the event rather than this.selectedIndex: that property is maintained by
          PageDots' own carousel:change listener, and relying on it here means relying on PageDots having
          been notified first. It usually has been, but "usually" is what left the bars reading one slide
          behind. detail.index is the value the carousel just moved to, full stop.
        */
        this.controlledElement?.addEventListener('carousel:change', (event) => this._reset(event.detail?.index), { signal });

        /*
          The player is only reachable once the controlled element has upgraded -- it is created in
          EffectCarousel's own connectedCallback, so before that the element is a plain HTMLElement and
          .player reads undefined.

          That is not guaranteed to have happened yet. This file is a <head> module, so it runs before any
          module inline in the body, and a carousel defined from inside a section (Slideshow (BL) defines
          <bl-slideshow-carousel> to lengthen its transition) is still undefined at this point. Reading
          .player here would come back empty, _hasPlayer would latch to false, and the bars would silently
          fall back to the static snapshot -- no growth animation, no error.

          Waiting on the definition instead makes this independent of which file defines the carousel and
          in what order, so it holds for the theme's own <slideshow-carousel> and any future subclass
          equally. The tag check is what distinguishes a custom element from a plain one; anything without
          a hyphen cannot be one and is wired immediately.
        */
        const controlledTag = this.controlledElement?.localName ?? '';

        if (controlledTag.includes('-') && !window.customElements.get(controlledTag)) {
          window.customElements.whenDefined(controlledTag).then(() => {
            if (!signal.aborted) {
              this._bindPlayer(signal);
            }
          });
        } else {
          this._bindPlayer(signal);
        }

        // Runs regardless, so the bars show a correct static state while a deferred definition resolves.
        this._reset();
      }

      _bindPlayer(signal) {
        const player = this.controlledElement?.player;
        this._hasPlayer = !!player;

        if (player) {
          player.addEventListener('player:start', (event) => this._grow(event.detail.duration), { signal });
          player.addEventListener('player:pause', () => this._growingControl?.pause(), { signal });
          player.addEventListener('player:resume', () => this._growingControl?.play(), { signal });
        }

        this._reset();
      }

      /*
        Fires on every slide change, and once on connect. The bars read as a progress track: everything
        before the current slide is full, everything after is empty.

        The current bar is the only one that differs by mode. With a Player it starts empty here and
        _grow() fills it in step with the autoplay timer; without one there is no timer to grow anything,
        so it is simply filled -- which is what makes the bars match the slide on show instead of trailing
        it by one.

        Widths are assigned outright and never animated back down: only the growth is animated. Stopping
        the running grow first matters, or it would keep writing width to the bar it was part-way through.
      */
      _reset(index) {
        this._growingControl?.stop();
        this._growingControl = null;

        // No argument on connect and when the player binds; there the inherited index is the only source.
        const current = Number.isInteger(index) ? index : this.selectedIndex;

        this._fills.forEach((fill, index) => {
          if (index < current) {
            fill.style.width = '100%';
          } else if (index > current) {
            fill.style.width = '0%';
          } else {
            fill.style.width = this._hasPlayer ? '0%' : '100%';
          }
        });
      }

      // Grows the current bar from 0% to 100% over the autoplay duration -- the only animation left here.
      _grow(duration) {
        const fill = this._fills[this.selectedIndex];

        if (!fill) {
          return;
        }

        fill.style.width = '0%';
        this._growingControl = animate(fill, { width: ['0%', '100%'] }, { duration, easing: 'linear' });
      }
    }
  );
}

/*
  ------------------------------------------------------------------------------------------------------------------------
  Scroll reveal -- SHARED SCROLL ANIMATION
  ------------------------------------------------------------------------------------------------------------------------

  Generic entrance, shared across sections (see CLAUDE.local.md's rule on shared behavior living here
  rather than duplicated per section) -- first used by Collection list (BL), for both the header's
  slide-in and the card grid's stagger-in.

  ONE-SHOT, not scroll-linked. This used to be genuinely tied to scroll position (Motion One's scroll(),
  the same function the theme's own revealed-image-on-scroll.js uses), which meant scrolling back up out
  of an element's window played its entrance in reverse and left it hidden again. Every reveal now fires
  once, the first time the element comes into view, and plays on a clock from there -- scrolling past it
  and coming back finds it settled. Motion One's inView() is the trigger, and the observer stops itself
  the moment it fires, so nothing is left watching a revealed element.

  Plain attribute-driven rather than a custom element, so it can be dropped onto any existing element (a
  heading, a content block, one item inside a loop) without needing to restructure markup around a new
  wrapper tag -- a wrapper would break any CSS relying on that element's original position in the tree
  (Collection list (BL)'s ".prose > h2" max-width/alignment rules, for one).

  [bl-scroll-reveal="left|right|up"] on an element gives THAT element its own entrance -- "up" (or any
  other/no value) is a plain upward nudge, "left"/"right" slide in from that side. Put it on as many
  elements independently as needed (e.g. every card in a loop): since each waits on its own position,
  items lower on the page naturally reveal later even with no stagger attributes at all.

  Optional "stagger-index"/"stagger-step" pair, for a group of same-direction items (e.g. every card in
  Collection list (BL)'s grid) that would otherwise all cross the trigger line together and reveal in one
  flat batch instead of a cascade: "stagger-index" is the item's 0-based position, "stagger-step" is
  "<mobile step> <desktop step>" (evaluated against a 700px breakpoint when the item plays) -- 0 disables
  the stagger entirely for that breakpoint, letting it differ independently on mobile vs desktop.

  A step is still expressed in the percentage-of-viewport points it meant under the scroll-linked version,
  so the numbers already sitting in the sections keep their relative weight; BL_SCROLL_REVEAL_STAGGER_PER_POINT
  converts them into the delay they now stand for. Negative indices clamp to no delay: they used to mean
  "start EARLIER than index 0", which a delay cannot express (Hot spots (BL) carried the only pair, and
  was renumbered 0/2 rather than -2/0 to keep the same offset between its two lines).

  Optional "bl-scroll-reveal-min-width" (a plain pixel number, e.g. "700"), for an element that should
  only get the effect above some width and stay plainly visible below it (Feature highlights (BL)'s
  items, which already animate in via their own mobile layout and don't need a second effect stacked on
  top). Checked live on resize -- crossing the given width without a reload arms or disarms the element
  rather than leaving it stuck with whichever it was born with.

  Optional "bl-scroll-reveal-distance" (any valid CSS length, e.g. "var(--spacing-12)"), overriding how
  far this one element travels -- BL_SCROLL_REVEAL_OFFSET_X/Y below are shared defaults for every element
  on the page, but a given item can call for a more subdued or more pronounced slide than its neighbours.
  Nothing in the theme currently sets it: Feature highlights (BL) used to, on two of its items, but those
  moved to the [bl-reveal-target] cascade further down and no longer carry [bl-scroll-reveal] at all. Kept
  as the escape hatch for the next element that needs to differ from the shared distance.

  The scroll-linked version also took an "offset" attribute (a full override of its reveal window, as a
  pair of Motion One scroll offsets). There is no window left to override, so it is gone -- nothing in the
  theme ever set it.

  Deliberately not reusing the theme's own <collection-list>/<reveal-items> reveal mechanisms: neither
  supports a left/right direction or a stagger, and <reveal-items> is additionally gated behind the
  theme's global "stagger products apparition" setting, which this needs to work independent of.

  Re-run against a single section on "shopify:section:load" (theme editor re-renders), same as the
  header-inset behaviour above.
*/
import { animate as blAnimate, inView as blInView } from 'vendor';

/*
  How far the element travels while it is being revealed. Purely visual distance -- it does not change how
  long the reveal takes (that is BL_SCROLL_REVEAL_DURATION below), only how much ground the element covers
  in it, so raising these makes the same window read as a longer, more deliberate slide.

  Y was var(--spacing-16) (64px), which barely registered next to the fade, then var(--spacing-24) (96px).
  var(--spacing-32) (128px) is a third further again, so the travel reads as the point of the animation
  rather than as a nudge accompanying the fade.

  Kept off the horizontal pair, which slide inside their own line box where a wide offset would push text
  past the section edge before it settles.

  Individual elements can still opt out with bl-scroll-reveal-distance (see above). Nothing sets it today,
  so this value is what every vertical reveal in the theme travels.
*/
const BL_SCROLL_REVEAL_OFFSET_X = 'var(--spacing-10)';
const BL_SCROLL_REVEAL_OFFSET_Y = 'var(--spacing-32)';

/*
  How long the entrance takes, in seconds (Motion One's unit), and how far into the viewport the element
  has to come before it starts.

  The scroll-linked version had no duration at all -- it played exactly as fast as you scrolled, which is
  what made it easy to miss at speed and what the repeated widening of its window kept trying to
  compensate for. A clock is immune to that: a fast scroll no longer outruns the animation, it just means
  the element is already on screen while it plays.

  The margin trims the bottom of the viewport so an element has to be properly on screen rather than one
  pixel past the edge before it fires. A margin rather than an intersection ratio because ratios are
  relative to the element's own size: a section taller than the viewport can never reach a 0.2 ratio and
  would never reveal at all, while a margin is measured against the viewport and behaves the same at any
  element height.
*/
const BL_SCROLL_REVEAL_DURATION = 0.9;
const BL_SCROLL_REVEAL_MARGIN = '0px 0px -10% 0px';
const BL_SCROLL_REVEAL_EASING = [0.22, 1, 0.36, 1];
const BL_SCROLL_REVEAL_DESKTOP_QUERY = '(min-width: 700px)';

/*
  Seconds of delay per point of "stagger-step", and the longest delay any one item may be given.

  The cap is what stops a long list running away: with a step of 14 the cascade covers roughly the first
  three items and everything past that shares the same delay rather than being held back further and
  further. 0.45s matches the 45 points the scroll-linked version capped its own shift at, so lists tuned
  against that cap behave the same.
*/
const BL_SCROLL_REVEAL_STAGGER_PER_POINT = 0.01;
const BL_SCROLL_REVEAL_MAX_STAGGER = 0.45;

/*
  ---- Wide screens: the fade lands before the slide does ----

  From 1440px up, opacity finishes partway through the entrance instead of at the end of it. On a wide
  screen the element is travelling across a lot more pixels, so it spends much longer visible-but-
  translucent; landing the fade early lets it read as solid while it is still covering the last of the
  distance.

  Two attributes override that per element, both applying at every width rather than only above the
  breakpoint:

    full-fade                    opacity runs the whole entrance, never split. Carried by the section-level
                                  reveals on Feature cards (BL) and Hot spots (BL), which bring a whole
                                  section in as one block -- an early-landing opacity would make the
                                  section look settled while it was still moving.
    bl-scroll-reveal-fade="0.4"  opacity is done 40% of the way through, for an element that should read
                                  as solid well before it stops travelling (a lower number lands sooner;
                                  the shared default below is 0.55).

  Absent, an element takes the wide-screen default below and nothing under that breakpoint. Both are read
  when the element plays rather than when it binds, so a window resized before the element is reached gets
  the treatment matching the width it is actually revealed at -- no resize rebuild needed.
*/
const BL_SCROLL_REVEAL_WIDE_QUERY = '(min-width: 1440px)';
const BL_SCROLL_REVEAL_WIDE_FADE = 0.55;

// Armed but not yet played (value is the inView stop function) vs. played and finished with. Two stores
// rather than one, because "already handled, leave alone" has to cover both while the resize rebind must
// only ever touch the first.
const blScrollRevealStops = new WeakMap();
const blScrollRevealPlayed = new WeakSet();

function blScrollRevealKeyframes(direction, distance) {
  switch (direction) {
    case 'left':
      return [`translateX(calc(-1 * ${distance || BL_SCROLL_REVEAL_OFFSET_X}))`, 'translateX(0)'];
    case 'right':
      return [`translateX(${distance || BL_SCROLL_REVEAL_OFFSET_X})`, 'translateX(0)'];
    default:
      return [`translateY(${distance || BL_SCROLL_REVEAL_OFFSET_Y})`, 'translateY(0)'];
  }
}

function blScrollRevealDelay(element) {
  const index = parseInt(element.getAttribute('stagger-index')) || 0;
  const [mobileStep, desktopStep] = (element.getAttribute('stagger-step') || '0 0').split(' ').map(Number);
  const step = (window.matchMedia(BL_SCROLL_REVEAL_DESKTOP_QUERY).matches ? desktopStep : mobileStep) || 0;

  return Math.min(Math.max(index * step, 0) * BL_SCROLL_REVEAL_STAGGER_PER_POINT, BL_SCROLL_REVEAL_MAX_STAGGER);
}

function blScrollRevealPlay(element) {
  if (blScrollRevealPlayed.has(element)) {
    return;
  }
  blScrollRevealPlayed.add(element);

  const [from, to] = blScrollRevealKeyframes(
    element.getAttribute('bl-scroll-reveal'),
    element.getAttribute('bl-scroll-reveal-distance')
  );
  const delay = blScrollRevealDelay(element);

  const customFade = parseFloat(element.getAttribute('bl-scroll-reveal-fade'));
  const splitFade =
    !element.hasAttribute('full-fade') &&
    (!isNaN(customFade) || window.matchMedia(BL_SCROLL_REVEAL_WIDE_QUERY).matches);
  const fadeFraction = isNaN(customFade) ? BL_SCROLL_REVEAL_WIDE_FADE : customFade;

  // Two calls rather than one set of keyframes: the split fade needs opacity on a shorter duration than
  // the transform, and a single animate() gives both properties the same timing.
  blAnimate(
    element,
    { transform: [from, to] },
    { duration: BL_SCROLL_REVEAL_DURATION, delay, easing: BL_SCROLL_REVEAL_EASING }
  );
  blAnimate(
    element,
    { opacity: [0, 1] },
    {
      duration: splitFade ? BL_SCROLL_REVEAL_DURATION * fadeFraction : BL_SCROLL_REVEAL_DURATION,
      delay,
      easing: BL_SCROLL_REVEAL_EASING
    }
  );
}

function blScrollRevealBind(element) {
  if (blScrollRevealPlayed.has(element)) {
    return;
  }

  blScrollRevealStops.get(element)?.();
  blScrollRevealStops.delete(element);

  const minWidth = element.getAttribute('bl-scroll-reveal-min-width');
  if (minWidth && !window.matchMedia(`(min-width: ${minWidth}px)`).matches) {
    // Nothing is going to animate it below this width, and [bl-scroll-reveal]'s own CSS opacity: 0 is
    // what it would otherwise be left sitting at.
    element.style.opacity = '1';
    return;
  }

  element.style.opacity = '';

  let stop;
  stop = blInView(
    element,
    () => {
      stop?.();
      blScrollRevealStops.delete(element);
      blScrollRevealPlay(element);
    },
    { margin: BL_SCROLL_REVEAL_MARGIN }
  );

  // Skipped if the callback above already fired -- storing the stop then would leave a dead entry behind
  // that the resize rebind would try to call.
  if (!blScrollRevealPlayed.has(element)) {
    blScrollRevealStops.set(element, stop);
  }
}

function initBlScrollReveal(root = document) {
  if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    return;
  }

  root.querySelectorAll('[bl-scroll-reveal]').forEach((element) => {
    if (blScrollRevealStops.has(element) || blScrollRevealPlayed.has(element)) {
      return;
    }
    blScrollRevealBind(element);
  });
}

// Only the width-gated ones, and only while they are still waiting: every other choice this makes is now
// deferred to the moment the element plays, so a resize has nothing left to invalidate.
let blScrollRevealResizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(blScrollRevealResizeTimer);
  blScrollRevealResizeTimer = setTimeout(() => {
    document.querySelectorAll('[bl-scroll-reveal][bl-scroll-reveal-min-width]').forEach(blScrollRevealBind);
  }, 200);
});

initBlScrollReveal();
document.addEventListener('shopify:section:load', (event) => initBlScrollReveal(event.target));

/*
  ------------------------------------------------------------------------------------------------------------------------
  Open accordion on scroll -- SHARED, one-shot
  ------------------------------------------------------------------------------------------------------------------------

  [bl-open-on-scroll] on an <details is="accordion-disclosure"> (see accordion.liquid's "open_on_scroll"
  param) opens it the first time it scrolls into view, via the element's own "open" setter -- same as the
  sibling-closing accordions do (bl_media-with-faq.liquid and friends) -- so it still plays the normal
  animated expand rather than snapping open. Disconnects its own observer immediately after, so scrolling
  it in and out of view again never replays the animation. First used by product-info.liquid's "Product
  specifications" block, opened once the shopper scrolls that far down the product page.

  A plain IntersectionObserver rather than bl-scroll-reveal above: this only ever needs a one-shot trigger,
  not something tied continuously to scroll position, and it changes real state (open/closed) rather than
  a purely visual transform/opacity.
*/
function initBlOpenOnScroll(root = document) {
  root.querySelectorAll('[bl-open-on-scroll]').forEach((details) => {
    if (details.open) {
      return;
    }

    // rootMargin, not a timer: shrinking the effective viewport by 30% off the bottom means the element's
    // top has to scroll further up past that shrunk line before it counts as intersecting at all, so it
    // opens once it has travelled further into the screen rather than the instant any part of it appears.
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          details.open = true;
          observer.disconnect();
        }
      });
    }, { rootMargin: '0px 0px -30% 0px' });

    observer.observe(details);
  });
}

initBlOpenOnScroll();
document.addEventListener('shopify:section:load', (event) => initBlOpenOnScroll(event.target));

/*
  ------------------------------------------------------------------------------------------------------------------------
  ZOOM ON SCROLL
  ------------------------------------------------------------------------------------------------------------------------

  [bl-zoom-on-scroll] plays a slow zoom OUT: the image starts enlarged and settles to its true size as the
  section comes into view, rather than growing as you scroll. Same scale the theme's own
  revealed-image-on-scroll runs on its backdrop (theme.js), so sections sharing a page read as one piece.

  ONE-SHOT, like [bl-scroll-reveal] above and for the same reason -- it used to be scroll-LINKED, so the
  image re-enlarged as you scrolled back up past it. It now fires once, the first time any part of the
  image enters the viewport, and plays on a clock. That also retires the whole offset/resize apparatus the
  scroll-linked version needed: its end point was a pixel value computed from the header and viewport
  heights, so every reveal had to be rebuilt on resize to stay honest. A duration needs none of that.

  The attribute goes on the WRAPPER, not on the image -- what animates is the wrapper's inner img/svg. That
  split is the whole point: a scaled element cannot be clipped by its own overflow, only by an ancestor's,
  and the one ancestor that would do it (.content-over-media) has to keep overflow visible in Hot spots (BL)
  so the dots and their ping rings can sit outside the frame. Animating the image one level down means the
  wrapper -- a <picture>, which nothing else relies on for layout -- can carry overflow: hidden and clip the
  zoom on its own. It also sidesteps the fact that Liquid's image_tag filter takes no hyphenated attribute,
  so the attribute could not have gone on the img from a template anyway.

  Lives here rather than in the section because there is no editor-safe way to bind it locally. An inline
  <script> does not re-execute when the theme editor re-renders a section, so section-local JS has to be a
  custom element to survive that -- and a custom element needs a tag of its own, which means either wrapping
  the picture (breaking theme.css's .content-over-media > picture selectors) or parking a dummy hidden
  element in the markup purely as a binding hook. The attribute scan below already re-runs on section:load,
  so it gets that for free.

  Separate from bl-scroll-reveal above rather than another direction keyword on it: that one always fades
  opacity 0 -> 1 as part of its entrance, which would double up with the fade already running on the section
  wrapper and hold the image back twice. This animates transform only, and over roughly twice as long --
  it reads as the approach of the section rather than as its entrance.
*/
const BL_ZOOM_ON_SCROLL_FROM = 1.15;
const BL_ZOOM_ON_SCROLL_DURATION = 1.6;
const blZoomOnScrollStops = new WeakMap();
const blZoomOnScrollPlayed = new WeakSet();

function blZoomOnScrollBind(element) {
  if (blZoomOnScrollPlayed.has(element)) {
    return;
  }

  // Falls back to the element itself so the attribute still does something if it is ever put directly on
  // an image, even though nothing can clip it in that position.
  const target = element.querySelector('img, svg') || element;

  // No margin: the zoom is meant to be already underway as the image climbs into view, which is what the
  // scroll-linked version's "start end" start point gave it.
  let stop;
  stop = blInView(element, () => {
    stop?.();
    blZoomOnScrollStops.delete(element);

    if (blZoomOnScrollPlayed.has(element)) {
      return;
    }
    blZoomOnScrollPlayed.add(element);

    blAnimate(
      target,
      { transform: [`scale(${BL_ZOOM_ON_SCROLL_FROM})`, 'scale(1)'] },
      { duration: BL_ZOOM_ON_SCROLL_DURATION, easing: [0.22, 1, 0.36, 1] }
    );
  });

  if (!blZoomOnScrollPlayed.has(element)) {
    blZoomOnScrollStops.set(element, stop);
  }
}

function initBlZoomOnScroll(root = document) {
  if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    return;
  }

  root.querySelectorAll('[bl-zoom-on-scroll]').forEach((element) => {
    if (blZoomOnScrollStops.has(element) || blZoomOnScrollPlayed.has(element)) {
      return;
    }
    blZoomOnScrollBind(element);
  });
}

initBlZoomOnScroll();
document.addEventListener('shopify:section:load', (event) => initBlZoomOnScroll(event.target));

/*
  ------------------------------------------------------------------------------------------------------------------------
  <bl-reveal-on-view> -- SHARED CASCADING FADE-IN
  ------------------------------------------------------------------------------------------------------------------------

  Adds "is-revealed" to the element named in its "for" attribute the first time that element comes into
  view, and never takes it off again. The matching CSS lives in bl_custom.css against [bl-reveal-target];
  this file only ever moves the class.

  ONE-SHOT. It used to toggle the class back off once the target had left the viewport entirely, so the
  cascade replayed on every return visit -- which took a second observer to watch for the leave, and a
  transition-suppressing dance in _reset() to stop the items animating on the way back out. All of that is
  gone: the reveal observer disconnects itself the moment it fires, so a revealed section stays revealed
  and nothing is left watching it.

  Used by Feature cards (BL), Feature highlights (BL), Quick nav (BL) and Media with FAQ (BL). Here rather
  than inline in a section because more than one section needs the same behaviour (see CLAUDE.local.md).

  An IntersectionObserver rather than reusing [bl-scroll-reveal] above: that one animates a single element,
  where this releases a whole container's children on a CSS stagger.

  A threshold ratio would have been the obvious way to express "properly in view", but ratios are relative
  to the element's own size: a target taller than the viewport can never reach 0.2, and would then never
  reveal at all. A rootMargin is measured against the viewport, so it behaves the same whatever the
  target's height turns out to be.

  How far in that trim goes is the optional "reveal-inset" attribute, a plain percentage of viewport
  height, defaulting to 10. Raising it holds the cascade back until more of the target has scrolled in,
  which suits a tall stacked list more than a single row of cards -- hence per-instance rather than one
  number for everything.

  The class lands on the container, not on each item, so every item is released together and staggers
  itself through CSS -- including any sitting outside the visible area of a horizontal scroller.
  Observing items individually would leave those hidden until scrolled sideways into view, so a shopper
  swiping the row would meet blank items fading in under their finger.

  A standalone element with a "for" reference rather than a wrapper, so it can be pointed at a container
  whose position in the tree is already load-bearing -- Feature cards (BL)'s carousel has to stay a direct
  sibling of its arrows and dots, and its items are its own direct children, leaving no layer either side
  of it free to wrap.
*/
if (!window.customElements.get('bl-reveal-on-view')) {
  window.customElements.define('bl-reveal-on-view', class extends HTMLElement {
    connectedCallback() {
      this._target = document.getElementById(this.getAttribute('for'));

      if (!this._target) {
        return;
      }

      // Matches bl_custom.css, which only ever hides the items under this same query.
      if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
        this._target.classList.add('is-revealed');
        return;
      }

      // parseFloat, then a finite check, so a missing or unparseable attribute falls back rather than
      // producing rootMargin: "-NaN% ..." -- which the observer rejects outright, taking the reveal with
      // it and leaving the items hidden for good.
      const inset = parseFloat(this.getAttribute('reveal-inset'));
      const revealInset = Number.isFinite(inset) ? inset : 10;

      this._revealObserver = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this._target.classList.add('is-revealed');
          this._revealObserver.disconnect();
        }
      }, { rootMargin: `-${revealInset}% 0px -${revealInset}% 0px` });

      this._revealObserver.observe(this._target);
    }

    disconnectedCallback() {
      this._revealObserver?.disconnect();
    }
  });
}

/********************************************************
 * QUICK-BUY BUTTON ALIGNMENT (PRODUCT GRIDS)
 ********************************************************/

/**
 * The quick-buy button wraps under the title and price on its own, per card, so one long title left
 * every other card with the button still inline and the grid read as ragged. There is no CSS for "a
 * sibling wrapped", so the cards are measured here and stacked together.
 *
 * The whole grid moves as one, not row by row: stacking only the row that needs it still steps the
 * buttons between rows, which is the same raggedness one level up.
 *
 * Shared by Collection (BL) and Featured collection (BL); each supplies its own scoped CSS for
 * .bl-quick-buy-stacked.
 */
if (!window.customElements.get('bl-quick-buy-align')) {
  window.customElements.define('bl-quick-buy-align', class extends HTMLElement {
    connectedCallback() {
      this._sync = this._sync.bind(this);
      this._schedule = this._schedule.bind(this);
      this._sync();

      addEventListener('resize', this._schedule);

      // Filtering replaces the grid wholesale, so the new cards need measuring too.
      this._observer = new MutationObserver(this._schedule);
      this._observer.observe(this, { childList: true, subtree: true });

      // Images and webfonts both change card heights after the first pass, and neither fires resize
      // nor mutates the DOM -- without these the grid keeps whatever it measured before they landed.
      this._resizeObserver = new ResizeObserver(this._schedule);
      this._resizeObserver.observe(this);
      document.fonts?.ready.then(this._schedule);
    }

    disconnectedCallback() {
      removeEventListener('resize', this._schedule);
      this._observer?.disconnect();
      this._resizeObserver?.disconnect();
      cancelAnimationFrame(this._frame);
    }

    _schedule() {
      cancelAnimationFrame(this._frame);
      this._frame = requestAnimationFrame(this._sync);
    }

    _sync() {
      const rows = Array.from(this.querySelectorAll('.product-card__title-price-row'));
      if (rows.length === 0) return;

      // Cleared first: the measurement has to read natural wrapping, not the last pass's result.
      rows.forEach((row) => row.classList.remove('bl-quick-buy-stacked'));

      // One decision for the whole grid rather than one per row: a single card long enough to push its
      // cart button under the price puts every other card's button there too, so the buttons stay on one
      // line across the page instead of stepping between rows.
      const wrapped = rows.some((row) => {
        const text = row.querySelector(':scope > .v-stack');
        const button = row.querySelector('.product-card__mobile-quick-buy-button');
        if (!text || !button) return false;

        return button.getBoundingClientRect().top >= text.getBoundingClientRect().bottom - 2;
      });

      // toggle with an explicit state rather than add: a pass that stacks nothing has to clear the
      // previous one. The net DOM state is unchanged when nothing moved, which is what stops the
      // ResizeObserver above from being fed its own output.
      for (const row of rows) {
        row.classList.toggle('bl-quick-buy-stacked', wrapped);
      }
    }
  });
}
